import { render } from "./NotificationOffcanvas.vue?vue&type=template&id=fc3d557c"
import script from "./NotificationOffcanvas.vue?vue&type=script&lang=js"
export * from "./NotificationOffcanvas.vue?vue&type=script&lang=js"

import exportComponent from "/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__